<template>
  <modal name="mynavi-ms-dialog" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true" @before-close="handleBeforeClose">
    <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
      <el-button @click="closeMynaviMsDialog" icon="el-icon-circle-close" style="font-size: 2rem;"
        type="text"></el-button>
    </div>
    <div class="setting" v-if="permissionType == 1">
      <div class="setting-item" style="text-align:center;">
        <p style="font-size: 140%;">ダウンロードが完了しました！！！</p>
        <p style="font-size: 140%;">経理・人事・法務・情シスなど<br>バックオフィスの好条件求人を最速で紹介するよ！<br>
          ほんとに自分の年収は適正かな？<br>
          今、探している求人と比較してみよう！<br>
          （非公開求人多数）
        </p>
        <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="true">
          <p style="font-size: 140%;">
            <img src="/static/renew_img/mynavimsenior_yagish_logo.png" style="width:100%">
          </p>
        </div>
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p style="font-size: 140%;">
            <img src="/static/renew_img/check_icon.png" style="width:40px">規約に同意して無料人材サービスを希望する
          </p>
        </div>
        <div class="text-center" style="padding:10px">
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isMynaviMsSended == false"
            style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
            @click="$eventHub.$emit('send-mynavi-ms-consult');">希望する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isMynaviMsSended == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeMynaviMsDialog();">送信しました</el-button>
          <br />
        </div>
        <p>
          Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
            target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
            target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
            target="_blank">プライバシーポリシー</a><br />
          マイナビミドルシニアの<a href="https://ms-mynavi.jp/jinzai/policy.html" target="_blank">利用規約</a>、<a
            href="https://ms-mynavi.jp/jinzai/privacy.html" target="_blank">個人情報保護方針</a>
        </p>
        <br>
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p style="font-size: 140%;">副業を探している人は、</p>
          <p style="font-size: 140%;">こちらのアルバイトサイトにも登録してみてね！</p>
        </div>
        <div class="text-center" style="padding:10px">
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isJigenSended == false"
            style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
            @click="$eventHub.$emit('send-jigen-consult-mynavidialog');">登録する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isJigenSended == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeMynaviMsDialog();">送信しました</el-button>
          <br />
        </div>
        <p>
          アルバイトEXの<a href="https://arubaito-ex.jp/terms" target="_blank">利用規約</a>、<a
            href="https://arubaito-ex.jp/privacy" target="_blank">個人情報保護方針</a>
        </p>
      </div>
    </div>
  </modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
import { emitRtDialogClosedWithoutSubmit, wrapMittPopupHandler } from '@/plugins/emitter'
export default {
  components: {
  },
  data: function () {
    return {
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      permissionType: 1,
      isMynaviMsSended: false,
      isMedlySended: false,
      isAdtopSended: false,
      isJigenSended: false,
      fullscreenLoading: false,
      clientId: 'mynavi_mail',
      username: '',
      baite_title: 'バイト',
      isAgree: true
    }
  },
  created: function () {
    const app = this
    this.$iterateStorage(function (value, key, iterationNumber) {
      // console.log all the kay/value pairs
      if (key === 'basicData') {
        app.username = value.lastName + '_' + value.firstName
      }
    }, function (err) {
      if (!err) {
        console.log('Iteration has completed')
      }
    })
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    }
  },
  methods: {
    openMynaviMsDialog: function (id, html) {
      this.formatid = id
      this.previewHtml = html.$el.innerHTML
      this.$modal.show('mynavi-ms-dialog')
      this.clearLocalStorageConfirmVisible = false

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'mynavi-ms_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      formData.append('site_flag', 'r')
      formData.append('app_flag', this.$site.appFlag)
      const app = this
      this.$axios.post(this.$varuna.endPoints.displayDialog, formData, { timeout: 60000 })
      this.$iterateStorage(function (value, key, iterationNumber) {
        // console.log all the kay/value pairs
        if (key === 'basicData') {
          app.username = value.lastName + '_' + value.firstName
        }
      }, function (err) {
        if (!err) {
          console.log('Iteration has completed')
        }
      })
    },
    closeMynaviMsDialog: function () {
      this.$modal.hide('mynavi-ms-dialog')
      this.clearLocalStorageConfirmVisible = false
      // this.$router.push('/mypage')
    },
    handleBeforeClose: function (event) {
      if (!this.isMynaviMsSended && !this.isJigenSended) {
        this.$eventHub.$emit('update_rt_condition', this.clientId, this.permissionType)
        emitRtDialogClosedWithoutSubmit()
      }
    },
    confirmWin: function () {
      confirm('応募するデータを送信します。よろしいでしょうか。')
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    sendMynaviMsConsult: async function () {
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', this.$site.appFlag)
      formData.append('dialog_name', 'mynavi-ms_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '2')
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.sendMynaviMs, formData, { timeout: 60000 })
        .then(function (response) {
          app.isMynaviMsSended = true
          app.$globalVar.eventTag()
          app.$eventHub.$emit('update_rt_condition', app.clientId, app.permissionType)
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('send-jigen-consult-mynavidialog', this.sendJigenConsult)
    this.$eventHub.$on('send-mynavi-ms-consult', this.sendMynaviMsConsult)
    // emitGlobalVarPopupDialog → mitt 直購読（GLOBAL_VAR_POPUP_EVENT_TYPES / emitter.js）
    this._mittGVPopup_openMynaviMsDialog = wrapMittPopupHandler(this, 'openMynaviMsDialog')
    this.$emitter.on('open-mynavi-ms-dialog', this._mittGVPopup_openMynaviMsDialog)
    this.$eventHub.$on('popstate', this.closeMynaviMsDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('send-jigen-consult-mynavidialog', this.sendJigenConsult)
    this.$eventHub.$off('send-mynavi-ms-consult', this.sendMynaviMsConsult)
    this.$emitter.off('open-mynavi-ms-dialog', this._mittGVPopup_openMynaviMsDialog)
    this.$eventHub.$off('popstate', this.closeMynaviMsDialog)
  }
}
</script>
